// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-my-employees-subscription',
//   templateUrl: './my-employees-subscription.component.html',
//   styleUrls: ['./my-employees-subscription.component.scss']
// })
// export class MyEmployeesSubscriptionComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar, PageEvent } from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { forEach } from 'jszip';
import moment from 'moment';
import { BehaviorSubject, fromEvent, Observable, of } from 'rxjs';
// import { Observable, of } from 'rxjs';

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { tap, catchError, finalize } from 'rxjs/operators';

import Swal from 'sweetalert2';
import { debug } from 'util';
import { PatientMinimum } from '../../core/model/patient';
import { SearchPatientReq, SearchPatientRes } from '../../core/model/v2/practice/searchPatientList';
import { PatientContactPreferences } from '../../core/models/patient/contactPreferences';
import { Patient } from '../../core/models/patient/patient';
import { CommonService } from '../../core/services/v2/common.service';
import { EmployerService } from '../../core/services/v2/employer.service';
import { PatientService } from '../../core/services/v2/patient.service';
import { PracticeService } from '../../core/services/v2/practice.service';
import { UserService } from '../../core/services/v2/user.service';
import { UtilsService } from '../../core/services/v2/utils.service';
import { SidebarPhysicianEditComponent } from '../../physician/profile/physician/sidebar-physician-edit/sidebar-physician-edit.component';
import { PhysicianOptionService } from '../../physician/shared/physician-option/physician-option.service';
import { MyErrorStateMatcher } from '../../shared/components/MyErrorStateMatcher/MyErrorStateMatcher.component';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';
import {  SharedService } from 'src/app/core/services/v2/shared-employees-data.service';
import { SharedDataService } from 'src/app/core/services/v2/shared-emp-subscription.service';
import { Router } from '@angular/router';
import { PatientInsuranceDetail } from 'src/app/core/models/patient/patientInsuranceDetail';
import { HsaFsaPopupComponent } from '../hsa-fsa-popup/hsa-fsa-popup.component';
import { PDFDialogComponent } from 'src/app/signup-organization/pdf-dialog/pdf-dialog.component';


@Component({
  selector: 'app-my-employees-subscription',
  templateUrl: './my-employees-subscription.component.html',
  styleUrls: ['./my-employees-subscription.component.scss']
})
  //plan-coverage
export class MyEmployeesSubscriptionComponent implements OnInit {
  isUploading: boolean = false;
  file: File | null = null;

  @ViewChild('closeModal', { static: true }) private closeModal: ElementRef;
  @ViewChild('#addNewEmp', { static: false }) addNewEmp: any;
  @Output() toggleEditEvent = new EventEmitter();
  @Input() patientInsurances: PatientInsuranceDetail[];
  selectedTabIndex: number = 0;
filteredDataSource: any[] = [];
  originalCheckboxState: boolean = false;
  isDialogOpen = false;
  noActivePlan : boolean = false;

  pageLength = 10;
  pageIndex = 1;
  dataLength;
  searchData: Patient[];
  patientData: Patient;
  patientProfile: Patient;
  searchCriteria: string = "";
  employeeId: number;
  healthOrganizationId:number;
  toggleSidebar = false;
  activeId: number;
  sectionName: string = "referPatient";
  selectedPatient: Patient;
  selection = new SelectionModel<any>(true, []);
  sideBarHeader: string;
  @ViewChild(SidebarPhysicianEditComponent, { static: false })
  childComponent: SidebarPhysicianEditComponent;
  @ViewChild("patientSearchInput", { static: true })
  patientSearchInput: ElementRef;
  dataSource: SearchPatientRes[];
  displayedColumns: string[] = [
    // "select",
    "employeeName",
    // "contact",
    /* "hireDate",*/
    "email",
    // "startDate",
    // "endDate",
    // "status",
    "lastLoginDate",
    "HSA",
    // "FSA",
    "planSubscription",
    "employerSponser",
    "employerSponserProgram",
    // "actions",
  ];
  selectionCheckBox = new SelectionModel<any>(true, []);
  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  activationType: string;
  userId: number;
  employerId: number;
  currentUserId: number;
  disableSelectAll: boolean = false;
  isButtonDisabled: boolean = true;
  selectedEmployeeIds: number[] = [];
  category: number;
  selectedFilter: string = ""; // No default filter
  originalData: any[] = []; // Store original data for filtering
  showAll: boolean = false;
  selectedPlans: any[];
  employerSponsorFilter: string | boolean = ''; // Filter value
  benefitProgramFilter: boolean | string = '';
  hsaFilter: boolean | string = '';
  activeSubscriptions: any;
  subscriptionTypeIds: any;
  subscriptionTypeNames: any;
  togglePatientProfileSidebar = this.commonService.togglePatientProfileSidebar;
  showPatientProfile: boolean = false;

  openSection: string;
  subscriptionTypes: any;
  selectedTab: string;

  constructor(
    private practiceService: PracticeService,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private commonService: CommonService, private _userService: UserService,
    private patientsService: PatientService,
    private employerService: EmployerService,
    private datepipe: DatePipe,
    private _snackBar: MatSnackBar,
    private _utils: UtilsService,
    private sharedService: SharedService,
    private sharedDataService: SharedDataService,
    private router: Router,
    private cdr: ChangeDetectorRef

    ) { }
  changeIndex(event: PageEvent) {
    this.pageLength = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.searchPatient();
  }
  patient: PatientMinimum;
  patientCreated: boolean;
  createdPatient: any;
  errorUnverifiedNumber: boolean = false;
  maxDate: Date = new Date();
  selectedFile = null;
  matcher = new MyErrorStateMatcher();
  profileImgUrl: string;
  firstNameFormControl = new FormControl("", [Validators.required]);
  middleNameFormControl = new FormControl("", []);
  lastNameFormControl = new FormControl("", [Validators.required]);
  preferredNameFormControl = new FormControl("", []);
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  mobileContactNumberFormControl = new FormControl("", [Validators.required]);
  workContactNumberFormControl = new FormControl("", []);
  genderFormControl = new FormControl("", [Validators.required]);
  dobFormControl = new FormControl("", [Validators.required]);

  dataForm: FormGroup = new FormGroup({
    firstname: this.firstNameFormControl,
    middlename: this.middleNameFormControl,
    lastname: this.lastNameFormControl,
    prefName: this.preferredNameFormControl,
    email: this.emailFormControl,
    gender: this.genderFormControl,
    dob: this.dobFormControl,
    phone: this.mobileContactNumberFormControl,
    secphone: this.workContactNumberFormControl,
  });

  ngOnInit() {
    this.isUploading = false;
    this.employeeId = 0;
    this.patient = <PatientMinimum>{};
    console.log(this.physicianOptionService.getPhysician().userId);
    this.physicianOptionService.selectionChange$.subscribe(
      (_) => {
        this.searchCriteria = "";
        this.searchPatient();
      },
      (error) => {
        console.error(error);
      }
    );
    fromEvent(this.patientSearchInput.nativeElement, "keyup")
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.searchCriteria = text;
        this.searchPatient();
      });
      this.getUserDetails();
      // this.getCurrentPatientDetails();
      // this.filterByTab();

  }
  ngAfterViewInit() {
    this._userService.getUserDetails().subscribe(
      (userDetails) => {
        this.currentUserId = userDetails.id;
        this.searchPatient();
      },
      (error) => {
        console.error(error);
      },
      () => {
        //   this.loaderService.hide();
      }
    );

  }
  getUserDetails() {
    this.loaderService.show();
    this._userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        this.employerId = userDetails.employerId
        this.healthOrganizationId = userDetails.healthOrganizationId;

        console.log("This is userId: ", this.userId);
        console.log("This is employerId: ", this.employerId);
        console.log("This is healthOrganizationId: ", this.healthOrganizationId);

        this.getEmployerHealthSubscriptionByEmployerId();
        this.onSubscriptionAction();
      },
      (error) => { console.error(error); }
    );
  }
  showAllEmployees() {
    this.showAll = true;
    this.searchPatient();
  }

  // getCurrentPatientDetails(){
  //   this.patientsService.getCurrentPatientDetails().subscribe(
  //     (data: Patient) => {
  //       console.log("patient insurance details",data)
  //       this.patientProfile = data;
  //     },
  // )}
  // searchPatient() {
  //   const searchReq: SearchPatientReq = new SearchPatientReq();
  //   searchReq.userId = this.currentUserId;
  //   searchReq.pageIndex = this.pageIndex;
  //   searchReq.itemsCount = this.pageLength;
  //   searchReq.criteria = this.searchCriteria;
  //   searchReq.parenttype = "employer";
  //   searchReq.employerId = this.employerId;
  //   searchReq.healthOrganizationId = this.healthOrganizationId;

  //   if (searchReq.healthOrganizationId) {
  //     this.loaderService.show();
  //     this.practiceService.GetPatientsListByOrgId(searchReq).subscribe(
  //       (res) => {
  //         this.originalData = res.patients;  // Store the full data
  //         this.dataSource = [...this.originalData];  // Copy full data to dataSource
  //         this.searchData = res.patients;
  //         this.dataSource = res.patients;
  //         this.dataLength = res.totalRecords;
  //         if (this.dataLength < (this.pageIndex - 1) * this.pageLength)
  //           this.pageIndex = 1;
  //         this.loaderService.hide();
  //       },
  //       (error) => {  
  //         console.error(error);
  //         this.loaderService.hide();
  //       },
  //       () => {
  //         this.loaderService.hide();
  //       }
  //     );
  //   }
  // }
  // searchPatient() {
  //   const searchReq: SearchPatientReq = new SearchPatientReq();
  //   searchReq.userId = this.currentUserId;
  //   searchReq.pageIndex = this.showAll ? 1 : this.pageIndex;
  //   searchReq.itemsCount = this.showAll ? 9999 : this.pageLength;  // large number to get all
  //   searchReq.criteria = this.searchCriteria;
  //   searchReq.parenttype = "employer";
  //   searchReq.employerId = this.employerId;
  //   searchReq.healthOrganizationId = this.healthOrganizationId;
  
  //   if (searchReq.healthOrganizationId) {
  //     this.loaderService.show();
  //     this.practiceService.GetPatientsListByOrgId(searchReq).subscribe(
  //       (res) => {
  //         this.originalData = res.patients;
  //         this.dataSource = [...this.originalData];
  //         this.searchData = res.patients;
  //         this.dataLength = res.totalRecords;
  //         if (!this.showAll && this.dataLength < (this.pageIndex - 1) * this.pageLength) {
  //           this.pageIndex = 1;
  //         }
  //         this.loaderService.hide();
  //       },
  //       (error) => {
  //         console.error(error);
  //         this.loaderService.hide();
  //       },
  //       () => {
  //         this.loaderService.hide();
  //       }
  //     );
  //   }
  // }
  searchPatient() {
    const searchReq: SearchPatientReq = new SearchPatientReq();
    searchReq.userId = this.currentUserId;
    searchReq.criteria = this.searchCriteria;
    searchReq.parenttype = "employer";
    searchReq.employerId = this.employerId;
    searchReq.healthOrganizationId = this.healthOrganizationId;
  
    // Set a high number to fetch all data
    searchReq.pageIndex = 1;
    searchReq.itemsCount = 1000000;
  
    if (searchReq.healthOrganizationId) {
      this.loaderService.show();
      this.practiceService.GetPatientsListByOrgId(searchReq).subscribe(
        (res) => {
          this.originalData = res.patients;  // Store the full data
          this.dataSource = [...res.patients];  // Assign full data
          this.searchData = res.patients;
          this.dataLength = res.totalRecords;
          this.loaderService.hide();
            // Set filtered data for the initial tab
            // this.onTabChange(0);
            this.onTabChange(this.selectedTabIndex); // Filter based on selected tab

        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
    }
  }
  // Tab change handler
  onTabChange1(index: number) {
    if (index === 0) {
      // Active
      this.filteredDataSource = this.dataSource.filter(
        e => e.patientActiveSubscription && e.patientActiveSubscription.active
      );
    } else {
      // Inactive
      this.filteredDataSource = this.dataSource.filter(
        e => !e.patientActiveSubscription || !e.patientActiveSubscription.active
      );
    }
  }
  onTabChange(index: number): void {
    this.selectedTabIndex = index;
  
    if (index === 0) {
      // Subscribed
      this.filteredDataSource = this.dataSource.filter(
        e => e.patientActiveSubscription && e.patientActiveSubscription.active
      );
    } else {
      // Not Subscribed
      this.filteredDataSource = this.dataSource.filter(
        e => !e.patientActiveSubscription || !e.patientActiveSubscription.active
      );
    }
  }
  filterByTab() {
    if (this.selectedTabIndex === 0) {
      this.filteredDataSource = this.dataSource.filter(e => e.patientActiveSubscription && e.patientActiveSubscription.active);
    } else {
      this.filteredDataSource = this.dataSource.filter(e => !e.patientActiveSubscription || !e.patientActiveSubscription.active);
    }
  }
  // searchPatient(): void {
  //   this.sharedService.searchPatient(
  //     this.currentUserId,
  //     this.pageIndex,
  //     this.pageLength,
  //     this.searchCriteria
  //   ).subscribe(
  //     (res) => {
  //       this.dataSource = res.patients;
  //       this.dataLength = res.totalRecords;
  //       if (this.dataLength < (this.pageIndex - 1) * this.pageLength) {
  //         this.pageIndex = 1;
  //       }
  //     },
  //     (error) => {
  //       console.error(error);
  //     }
  //   );
  // }

  
  getLoggedInUserId() {
    // this.loaderService.show();
  }
  onSubmit(patient: PatientMinimum): void {
    if (this.dataForm.invalid) {
      return;
    }
    if (this.employeeId > 0) {
      this.patientProfile = { ...this.patientData };
      this.patientProfile.firstName = patient.firstName;
      this.patientProfile.lastName = patient.lastName;
      this.patientProfile.middleName = patient.middleName;
      this.patientProfile.preferredName = patient.preferredName;
      this.patientProfile.primaryEmailAddress = patient.primaryEmailAddress;
      this.patientProfile.mobileContactNumber = patient.mobileContactNumber;
      this.patientProfile.workContactNumber = patient.workContactNumber;
      this.patientProfile.gender = patient.gender;
      this.patientProfile.sex = patient.gender;
      this.patientProfile.birthDate = patient.dob.toISOString();
      this.update();
    }
    else {
      patient.employerId = this.employerId;
      patient.practitionerId = 0;
      this.loaderService.show();
      this.patientsService.createMinimumnPatient(patient).subscribe(
        (p) => {
          this.loaderService.hide();
          this.resetForm();
          this.hideModel();
          this.createdPatient = p;
          this.patientCreated = true;
          //this.save.emit(p);
          this.searchPatient();
          this._utils.showMessageSnackBar('Employee Added successfully.');
        },
        (error) => {
          this._utils.showMessageSnackBar(error,true);
          this.loaderService.hide();
          console.error(error);
          if (error.error === 21608) {
            this.patientCreated = true;
            this.errorUnverifiedNumber = true;
          } else {
            return;
          }
        }

      );
    }

  }

  cancel() {
    this.patientCreated = false;
    if (this.employeeId > 0) {
      this.hideModel();
    }
    else {
      this.resetForm();
    }
  }
  public hideModel() {
    this.employeeId = 0;
    this.closeModal.nativeElement.click();
  }
  resetForm() {
    this.firstNameFormControl.setValue(""),
      this.middleNameFormControl.setValue(""),
      this.lastNameFormControl.setValue(""),
      this.preferredNameFormControl.setValue(""),
      this.emailFormControl.setValue(""),
      this.genderFormControl.setValue(""),
      this.dobFormControl.setValue(""),
      this.mobileContactNumberFormControl.setValue(""),
      this.workContactNumberFormControl.setValue("")

  }
  // uploadFile(event) {
  //   this.selectedFile = event.target.files[0];

  //   const payload = new FormData();
  //   payload.append('PatientId', this.employeeId.toString());
  //   payload.append('ImageSource', this.selectedFile);

  //   this.patientsService.uploadPatientProfilePicture(payload).subscribe(
  //     (res) => {
  //       this.getPatientDetailsByUserId(this.employeeId);
  //     },
  //     (error) => { console.error(error); }
  //   );

  // }

  openEditEmployer(eid: number) {
    if (eid != undefined) {
      this.employeeId = eid;
    }
    this.getPatientDetailsByUserId(eid);
    document.getElementById("btnAddNewE").click();
  }
  closeEditEmployer() {
    this.employeeId = 0;
  }
  getPatientDetailsByUserId(id: number) {
    var self = this;
    this.loaderService
      .blockWithLoader(this.patientsService.getPatientDetailsById(id))
      .subscribe(
        (details) => {
          self.patientData = details;
          this.bindPatientData(self.patientData);
        },
        (error) => {
          console.error(error);
        }
      );
  }
  bindPatientData(patientData: Patient) {
    patientData.patientContactPreferences.forEach(x => {
      if (x.contactTypeId==4) {
        this.emailFormControl.setValue(x.contactValue);
      }
      if (x.contactTypeId == 2) {
        this.mobileContactNumberFormControl.setValue(x.contactValue);
      }
      if (x.contactTypeId == 3) {
        this.workContactNumberFormControl.setValue(x.contactValue);
      }
    });

    this.firstNameFormControl.setValue(patientData.firstName),
      this.middleNameFormControl.setValue(patientData.middleName),
      this.lastNameFormControl.setValue(patientData.lastName),
      this.preferredNameFormControl.setValue(patientData.preferredName),
      this.genderFormControl.setValue(patientData.sex),
      this.dobFormControl.setValue(new Date(patientData.birthDate));
  }
  update() {
    this.loaderService.show();
    this.patientsService.updatePatientDetails(this.patientProfile).subscribe(
      (_) => {
        this.loaderService.hide();
        this._snackBar.open('Update successful!.', 'Ok', { duration: 5 * 1000 });
        this.hideModel();
        this.searchPatient();
      },
      (error) => {
        this.loaderService.hide();
        this._snackBar.open('Error while updating record!.', 'Ok', { duration: 5 * 1000 });
        console.error(error);
      }
    );
  }
  calculateAge(birthDate: Date) {
    if (birthDate != undefined)
      return moment().diff(birthDate, 'years');
  }

  toggleEditSidebar(
    sectionName: string,
    patient: Patient,
    sideBarHeader: string
  ) {

    if (sectionName !== 'close') {
      this.sectionName = sectionName;
      if (this.sectionName == "communicateMultiplePatient") {
        //this.selection.select(...this.dataSource);
        this.selection = new SelectionModel<SearchPatientRes>(true, [...this.dataSource])
      }
      this.sideBarHeader = sideBarHeader;
      this.activeId = patient && patient.id ? patient.id : undefined;
      this.selectedPatient = patient;
      this.showHideScroll(this.toggleSidebar);
    }
    this.toggleSidebar = !this.toggleSidebar;
    this.destroyChild();
  }
  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }
  destroyChild() {
    if (this.childComponent) {
      this.childComponent.ngOnDestroy();
    }
  }
  togglePopUp() {
    // this.practitionerData = pracdata;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
  }

  attachFile(event) {

    let file: File;
    if (event[0]) {
      file = event[0];
    } else {
      file = event.target.files[0];
    }
    if (file.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      event.target.value = '';
      this._snackBar.open(
        `Invalid file type!`,
        "Ok",
        {
          duration: 5000,
        }
      );
      return false;
    }
    else if (file.size == 1024 * 10) {
      event.target.value = '';
      this._snackBar.open(
        `File size can't exceed 5 mb!'`,
        "Ok",
        {
          duration: 5000,
        }
      );
      return false;
    }
    this.isUploading = true;
    let empDataFileForm = new FormData();
    empDataFileForm.append('EmployeeDataSource', file);
    this.loaderService.show();

    this.
      employerService.uploadEmployeeData(
        empDataFileForm
      )
      .subscribe((res) => {
        this.isUploading = false;

        if (res != undefined) {
          this.loaderService.hide();
          event.target.value = '';
          event.target.files = null;
          this._snackBar.open(
            `Data Uploaded Successfully`,
            "Ok",
            {
              duration: 5000,
            }
          );
          this.searchPatient();
        } else {
          this.isUploading = false;
          this._snackBar.open(
            `Upload failed!`,
            "Ok",
            {
              duration: 5000,
            }
          );
        }
      },
        (error) => {
          this.isUploading = false;
          this.loaderService.hide();
          console.error(error);
          this._snackBar.open(
            `File could not be uploaded!${error.error && error.error.resultStatus
              ? ": " + error.error.resultStatus.message
              : ""
            }`,
            "Ok",
            {
              duration: 5000,
            }
          );
        });
    event.target.value = '';
    // this.isUploading = false;
    this.loaderService.hide();
  }

  // deleteEmployee(patient: Patient) {
  //   patient.active = false;
  //   Swal.fire({
  //     title: `Delete Employee`,
  //     text: `Are you sure want to delete this Employee?`,
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, Delete!'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       this.loaderService.blockWithLoader(this.patientsService.updatePatientDetails(patient)).subscribe(
  //         (res) => {
  //           if (res.isSuccess) {
  //             this.searchPatient();
  //             this._utils.showMessageSnackBar('Employee deleted successfully.');
  //           }
  //         },
  //         (error) => { console.error(error); },
  //       )
  //     }
  //   })

  // }
  deleteEmployee(id: number) {
    console.log("deleting userId",id);
    // patient.active = false;
    Swal.fire({
      title: `Delete Employee`,
      text: `Are you sure want to delete this Employee?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete!'
    }).then((result) => {
      console.log("result",result);
      if (result.isConfirmed) {
        this.loaderService.blockWithLoader(this.patientsService.deleteMemberPatients(id)).subscribe(
          (res) => {
            console.log("response",res);

            if (res.isSuccess) {
              this.searchPatient();
              this._utils.showMessageSnackBar('Employee deleted successfully.');
            }
          },
          (error) => { console.error(error); },
        )
      }
    })

  }

onFileChange(event: Event): void {
  const input = event.target as HTMLInputElement;

  if (input && input.files && input.files.length > 0) {
    this.file = input.files[0]; // Store the selected file
    this.uploadFile(this.employerId); // Automatically trigger file upload when file is selected
  }
}
@ViewChild('fileInput',{static:false}) fileInput!: any;
handleFileClick(){
  if(this.fileInput && this.fileInput.nativeElement && this.fileInput.nativeElement.value)
  this.fileInput.nativeElement.value = '';
if(this.file)
  this.file = null;
  this.fileInput.nativeElement.click();
}
uploadFile(employerId: number): void {
  if (!this.file) {
    this._utils.showMessageSnackBar('Please select file.',true);
    return;
  }
  // Create a FormData object to send the file and employerId
  const formData = new FormData();
  formData.append('employeeDataSource', this.file);
  formData.append('employerId', employerId.toString()); // Append employerId to FormData
  // formData.append('employerId', employerId.toString()); // Append employerId to FormData

  this.isUploading = true; // Set uploading flag to true
  this.loaderService.show();
  // Call the API with FormData
  this.employerService.bulkUploadEmployeeData(formData).subscribe(
    (res) => {
      this._utils.showMessageSnackBar(JSON.stringify(res));   
      // this.dataSource = res; // Assign the response array directly to the dataSource
      // this.displayedColumns = [  "employeeName",
      //   // "contact",
      //   /* "hireDate",*/
      //   "email",
      //   // "startDate",
      //   // "endDate",
      //   "status",
      //   "actions",]; // Optionally configure displayedColumns
      this.isUploading = false; // Set uploading flag to false after success
      this.loaderService.hide();
      this.searchPatient();
    },
    (error) => {
      this.loaderService.hide();
      this._utils.showMessageSnackBar(error.error,true);
      this.isUploading = false; // Set uploading flag to false on error
    }
  );
}
getEmailFromPreferences(preferences: any[]): string {
  if (!preferences || !preferences.length) {
    return 'N/A'; // Default value if no preferences are found
  }
  const emailPreference = preferences.find(pref => pref.contactType === 'Email');
  return emailPreference && emailPreference.contactValue ? emailPreference.contactValue : 'N/A';
}
// downloadFile() {
//   const fileUrl = 'assets/pdf/CensusTemplate.xlsx'; // Correct path to your assets folder
//   const anchor = document.createElement('a');
//   anchor.href = fileUrl;
//   anchor.download = 'CensusTemplate.xlsx'; // The file name for download
//   anchor.click();
//   anchor.remove(); // Clean up the created element

// }
 downloadFile() {
  const fileUrl = 'assets/pdf/CensusTemplate.xlsx'; // Correct path to your assets folder
  const anchor = document.createElement('a');

  // Check if the file exists before attempting to download
  fetch(fileUrl, { method: 'HEAD' })
    .then((response) => {
      if (response.ok) {
        anchor.href = fileUrl;
        anchor.download = 'CensusTemplate.xlsx'; // The file name for download
        anchor.click();
        anchor.remove(); // Clean up the created element
      } else {
        console.error('File not found or server error');
        alert('There was an issue with the file. Please check your internet connection or try again later.');
      }
    })
    .catch((error) => {
      console.error('Network error:', error);
      alert('Network error. Please check your internet connection.');
    });
}

toggleSelection(row: any) {
  if (row.patientActiveSubscription && row.patientActiveSubscription.active) return; // Prevent selection if disabled

  const index = this.selectedEmployeeIds.indexOf(row.id);
  if (index === -1) {
    this.selectedEmployeeIds.push(row.id);
  } else {
    this.selectedEmployeeIds.splice(index, 1);
  }
  this.updateButtonState();
}

toggleSelectAll(checked: boolean) {
  if (checked) {
    this.selectedEmployeeIds = this.dataSource
      .filter((row: any) => !(row.patientActiveSubscription && row.patientActiveSubscription.active)) // Only enabled checkboxes
      .map((row: any) => row.id);
  } else {
    this.selectedEmployeeIds = [];
  }
  this.updateButtonState();
}

isAllSelected(): boolean {
  if (!this.dataSource || this.dataSource.length === 0) return false;

  const selectableRows = this.dataSource.filter(row => !(row.patientActiveSubscription && row.patientActiveSubscription.active));
  return selectableRows.length > 0 && this.selectedEmployeeIds.length === selectableRows.length;
}


updateButtonState() {
  this.isButtonDisabled = this.selectedEmployeeIds.length === 0;
}
updatePatientHealthSubscription() {
  console.log("Navigating with:", this.selectedEmployeeIds);

  this.router.navigate(["/employer/addempCheckout"], { 
    state: { selectedEmployeeIds: this.selectedEmployeeIds } 
  });
}


  toggleEdit(patientInsurance: PatientInsuranceDetail) {
    if (patientInsurance) {
      this.toggleEditEvent.emit(patientInsurance);
    } else {
      this.toggleEditEvent.emit(new PatientInsuranceDetail());
    }
  }

 

  onCheckboxChange(element: any, field: string, isChecked: boolean) {
    // Store the initial state of the checkbox
    const initialHSAState = element.patientInsurances && element.patientInsurances.length > 0 ? element.patientInsurances[0].hasHSA : false;
    const initialFSAState = element.patientInsurances && element.patientInsurances.length > 0 ? element.patientInsurances[0].hasFSA : false;

    // Temporary state variable to manage checkbox state
    let tempState = isChecked;

    this.isDialogOpen = true; // Set dialog open state

    const dialogRef = this.dialog.open(HsaFsaPopupComponent, {
      width: '650px',
      minHeight: '350px',
      data: { message: `Do you want to add ${field.toUpperCase()}?` },
      panelClass: 'center-dialog' // Add custom panel class for centering
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isDialogOpen = false; // Reset dialog open state
      this.searchPatient();

      if (result) {
        // User confirmed, proceed with the logic
        if (!element.patientInsurances) {
          element.patientInsurances = [];
        }
        if (element.patientInsurances && element.patientInsurances.length > 0) {
          if (field === 'hsa' && isChecked) {
            element.patientInsurances[0].hasHSA = true;
            element.patientInsurances[0].hasFSA = false; // Uncheck FSA
          } else if (field === 'fsa' && isChecked) {
            element.patientInsurances[0].hasHSA = false; // Uncheck HSA
            element.patientInsurances[0].hasFSA = true;
          }
          this.updatePatientInsurance(element, field, isChecked);
        } else {
          this.addPatientInsurance(element.id, field, isChecked);
        }
      } else {
        // User canceled, revert the checkbox to its original state
        if (field === 'hsa') {
          tempState = initialHSAState;
          element.patientInsurances[0].hasHSA = initialHSAState;
        } else if (field === 'fsa') {
          tempState = initialFSAState;
          element.patientInsurances[0].hasFSA = initialFSAState;
        }
        this.cdr.detectChanges(); // Manually trigger change detection
      }
    });

    // Update the checkbox state based on the temporary state variable
    if (field === 'hsa') {
      element.patientInsurances[0].hasHSA = tempState;
    } else if (field === 'fsa') {
      element.patientInsurances[0].hasFSA = tempState;
    }
  }
  
  // API call to add a new insurance record
  addPatientInsurance(patientId: number, field: string, value: boolean) {
    const formData = new FormData();
    formData.append('patientId', patientId.toString());
  // Dynamically set category if available; otherwise, use a default value
  // const category = this.category || 1; // Replace 1 with a default category if necessary
  // formData.append('category', category.toString()); 
  formData.append('category', 'Medical');
   
    // Set correct field based on input
    if (field === 'hsa') {
      formData.append('hasHSA', value.toString());
      formData.append('hasFSA', 'false'); // Default to false if not selected
    } else if (field === 'fsa') {
      formData.append('hasHSA', 'false'); // Default to false if not selected
      formData.append('hasFSA', value.toString());
    }
  
    formData.append('active', 'true'); // Assuming always active when adding
  
    // this.patientsService.addPatientInsurance(formData).subscribe(
    //   response => console.log('Insurance Added:', response),
    //   error => console.error('Error Adding Insurance:', error)
    // );
    this.loaderService.show(); // Show loader before API call

this.patientsService.addPatientInsurance(formData).subscribe(
  (response) => {
    console.log('Insurance Added:', response);
    this.loaderService.hide(); // Hide loader on success
    this.searchPatient();
    // Refresh patient list after adding insurance
  },
  (error) => {
    console.error('Error Adding Insurance:', error);
    this.loaderService.hide(); // Hide loader on error
  },
  () => {
    this.loaderService.hide(); // Hide loader when request completes
  }
);

  }
  
  // API call to update an existing insurance record
  updatePatientInsurance(element: any,  field: string, value: boolean) {
    const insuranceRecord = element.patientInsurances[0]; // Get the first insurance record

    const formData = new FormData();
    formData.append('id',insuranceRecord.id);
    formData.append('patientId', insuranceRecord.patientId);
  // Preserve existing category if available
  // const category = this.category || 1;
  // formData.append('category', category.toString());
  formData.append('category', 'Medical');
  
    // Set correct field based on input
    if (field === 'hsa') {
      formData.append('hasHSA', value.toString());
      formData.append('hasFSA', 'false'); // Default to false if not selected
    } else if (field === 'fsa') {
      formData.append('hasHSA', 'false'); // Default to false if not selected
      formData.append('hasFSA', value.toString());
    }
  
    formData.append('active', 'true'); // Assuming the record is always active
  
    // this.patientsService.updatePatientInsurance(formData).subscribe(
    //   response => console.log('Insurance Updated:', response),
    //   error => console.error('Error Updating Insurance:', error)
    // );
    // Show the loader before making the API request
  this.loaderService.show();

  this.patientsService.updatePatientInsurance(formData).subscribe(
    (response) => {
      console.log('Insurance Updated:', response);
      this.searchPatient();
      // Refresh the data after successful update
      this.loaderService.hide(); // Hide the loader after success
    },
    (error) => {
      console.error('Error Updating Insurance:', error);
      this.loaderService.hide(); // Hide the loader on error
    },
    () => {
      this.loaderService.hide(); // Hide loader when request completes
    }
  );
  }
  applyFilter() {
    console.log("Selected Filter:", this.selectedFilter);
  
    if (!this.selectedFilter) {
      this.dataSource = [...this.originalData]; // Reset to full dataset if no selection
      return;
    }
  
    if (this.selectedFilter === "yes") {
      console.log("Filtering for active records (Yes).");
      this.dataSource = this.originalData.filter((item: any) => {
        // Check if patientActiveSubscription exists and if it is active (true)
        return item.patientActiveSubscription && item.patientActiveSubscription.active === true;
      });
    } else if (this.selectedFilter === "no") {
      console.log("Filtering for inactive records (No).");
      this.dataSource = this.originalData.filter((item: any) => {
        // Handle case where patientActiveSubscription is null and active is false
        return item.patientActiveSubscription === null || item.patientActiveSubscription.active === false;
      });
    }
  
    console.log("Filtered dataSource:", this.dataSource);
  }
  
  // Method to update employer sponsor status via API
  updateEmployerSponsor(element: Patient) {
    // Prepare the request payload to update the employerSponsor status
    const updateRequest: Patient = {
      ...element, // Keep all existing properties
      // employerSponsor: element.employerSponsor // Update only this field
      employerSponsor: element.employerSponsor // Force update to true

    };

    // Call the service method to update the data
    this.patientsService.updatePatientDetails(updateRequest).subscribe(
      (response) => {
        // Handle success, you can update the local data if needed
        console.log('Employer Sponsor updated successfully', response);
        // Fetch the updated patient list
      this.searchPatient();
      },
      (error) => {
        // Handle error, show an error message or handle it appropriately
        console.error('Error updating Employer Sponsor', error);
      }
    );
  }
    // Method to update employer sponsor status via API
    onProgramChange(element: Patient) {
      // Prepare the request payload to update the employerSponsor status
      // Assign a default plan if not already assigned
  if (!element.employerSponsorprogram && this.subscriptionTypeIds.length > 0) {
    element.employerSponsorprogram = this.subscriptionTypeNames;
    console.log("Assigned default employerSponsorprogram ID:", element.employerSponsorprogram);
  }
      const updateRequest: Patient = {
        ...element, // Keep all existing properties
        // employerSponsor: element.employerSponsor // Update only this field
        employerSponsorprogram: element.employerSponsorprogram // Force update to true
  
      };
  
      // Call the service method to update the data
      this.patientsService.updatePatientDetails(updateRequest).subscribe(
        (response) => {
          // Handle success, you can update the local data if needed
          console.log('Employer Sponsor updated successfully', response);
          // Fetch the updated patient list
        this.searchPatient();
        },
        (error) => {
          // Handle error, show an error message or handle it appropriately
          console.error('Error updating Employer Sponsor', error);
        }
      );
    }
  openPdfDialog() {
    let data = {
      title: 'Employer Template Instructions',
      filename: 'EMPLOYER_CENSUS_TEMPLATE_INSTRUCTIONS.pdf',
    }
  
  
    this.dialog.open(PDFDialogComponent, { panelClass:'pricing-pdf-modal', id: 'subscription_dialog', data: { ...data, isBack: false, } });
  }
  choseeActivatedPans(){
    //  this.router.navigate(["/employer/selectPlan"]);
    this.router.navigate(["/employer/selectPlan"], { 
      state: { selectedEmployeeIds: this.selectedEmployeeIds } 
    });
  }
  getEmployerHealthSubscriptionByEmployerId() {
    this.loaderService.show();
    this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
      (res) => {
        if (res && res.resultStatus && res.resultStatus.isSuccess && Array.isArray(res.result)) {
          // Filter all active subscriptions
          this.activeSubscriptions = res.result.filter(sub => sub.active);
  
          if (this.activeSubscriptions.length > 0) {
            this.selectedPlans = this.activeSubscriptions;
            this.noActivePlan = false;
  
            console.log("Selected Plans:", this.selectedPlans);
//             this.subscriptionTypeIds = activeSubscriptions.map(sub => sub.subscriptionTypeId);
// console.log("Subscription Type IDs:", this.subscriptionTypeIds);
// this.activeSubscriptions.forEach((sub, index) => {
//   this.activeSubscriptionId = sub.subscriptionTypeId
//   console.log(`Subscription ${index + 1} Type ID:`, this.activeSubscriptionId);
// });

// this.subscriptionTypeNames = this.activeSubscriptions.map(sub => sub.subscriptionType.id);
// console.log("All active subscriptionTypeNames:", this.subscriptionTypeNames);
this.subscriptionTypes = this.activeSubscriptions.map(sub => ({
  id: sub.subscriptionType.id,
  name: sub.subscriptionType.name
}));

            console.log("subTYpeid:",this.selectedPlans)
          } else {
            console.warn("No active subscription found.");
            this.selectedPlans = [];
            this.noActivePlan = true;
          }
        } else {
          console.warn("No subscription data returned.");
          this.selectedPlans = [];
          this.noActivePlan = true;
  
          const errorMessage = res.resultStatus && res.resultStatus.errorMessages
            ? res.resultStatus.errorMessages.join(", ")
            : "Failed to fetch subscription details.";
  
          this._utils.showMessageSnackBar(errorMessage, true);
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.selectedPlans = [];
        this.noActivePlan = true;
        this.loaderService.hide();
  
        this._utils.showMessageSnackBar("An error occurred while fetching employer health subscription.", true);
      }
    );
  }
  onSubscriptionAction() {
    // Check if selectedPlans is a valid array
    if (this.selectedPlans && Array.isArray(this.selectedPlans)) {
      const count = this.selectedPlans.length;
  
      if (count === 1) {
        // Only one active subscription
        this.methodA();  // Replace with your actual method like `this.updatePatientHealthSubscription();`
      } else if (count > 1) {
        // More than one active subscription
        this.methodB();  // Replace with your actual method like `this.chooseActivatedPlans();`
      } else {
        this._utils.showMessageSnackBar("No active subscriptions found.", true);
      }
    } 
  }
  methodA() {
    // Logic for single subscription
    console.log("Single active subscription found. Proceeding with update...");
    this.updatePatientHealthSubscription();
  }
  
  methodB() {
    // Logic for multiple subscriptions
    console.log("Multiple active subscriptions found. Prompting user to choose...");
     this.choseeActivatedPans();  // or whatever method you want
  }
  applyEmployerSponsorFilter() {
    if (this.employerSponsorFilter === '') {
      this.dataSource = [...this.originalData]; // Show all
    } else {
      this.dataSource = this.originalData.filter(item =>
        item.employerSponsor === (this.employerSponsorFilter === 'true' || this.employerSponsorFilter === true)
      );
    }
  }
  applyBenefitProgramFilter() {
    if (this.benefitProgramFilter === '') {
      this.dataSource = [...this.originalData];
    } else {
      const isActive = this.benefitProgramFilter === true || this.benefitProgramFilter === 'true';
      this.dataSource = this.originalData.filter((item: any) => {
        return item.patientActiveSubscription &&
               item.patientActiveSubscription.active === isActive;
      });
    }
  }
  applyHsaFilter() {
    if (this.hsaFilter === '') {
      this.dataSource = [...this.originalData];
    } else {
      const hasHsa = this.hsaFilter === true || this.hsaFilter === 'true';
      this.dataSource = this.originalData.filter(item => {
        const hasInsurance = item.patientInsurances && item.patientInsurances.length > 0;
        return hasInsurance && item.patientInsurances[0].hasHSA === hasHsa;
      });
    }
  }
  
  togglePatientSidebar(element) {
    this.selectedPatient = element;
    this.openSection = 'profile';
    this.togglePatientProfileSidebar = !this.togglePatientProfileSidebar;
    this.showPatientProfile = !this.showPatientProfile;
  }
  getFilteredSubscriptionTypes(element: any) {
    if (
      element.patientInsurances &&
      element.patientInsurances.length > 0 &&
      element.patientInsurances[0].hasHSA
    ) {
      return this.subscriptionTypes.filter(plan => plan.id === 5);
    }
    return this.subscriptionTypes;
  }
  // getProgramNameById(id: number): string {
  //   const program = this.subscriptionTypes.find(p => p.id === id);
  //   return program ? program.name : '';
  // }
  getProgramNameById(id: number): string {
    if (!this.subscriptionTypes || !Array.isArray(this.subscriptionTypes)) {
      return '';
    }
  
    const program = this.subscriptionTypes.find(function (program) {
      return program && program.id === id;
    });
  
    return program ? program.name : '';
  }
  
  
  tabChanged(event: any) {
    this.selectedTab = event.index;
    console.log("tab subscribtion tab",this,this.selectedTab)
  }
}
